export default "__VITE_ASSET__BHbWUHzQ__"